export const getItems = ({ products }) => {
    if (!products.length) return []

    return products.map((product, index) => {
        return getItem({ product, index })
    })
}

export const getItem = ({ product, index }) => {
    if (!product && !product.partNumber) return {}
    const primaryCategory = product.masterCategory || {}
    const subCategory1 = primaryCategory.child || {}
    const subCategory2 = subCategory1.child || {}
    const gender = product.analyticsAttributes?.gender

    return {
        productInfo: {
            sku: product.partNumber,
            size: 'one size',
            productName: product.name,
            manufacturer: product.designerName,
            manufacturerID: product.designerIdentifier,
            ...(gender ? { gender } : {}),
        },
        category: {
            primaryCategory: primaryCategory.label || '',
            subCategory1: subCategory1.label || '',
            subCategory2: subCategory2.label || '',
        },
        attributes: {
            categoryIdList: [primaryCategory.identifier || '', subCategory1.identifier || '', subCategory2.identifier || ''],
            position: index ? index + 1 : undefined,
            saleFlag: product.onSale ? 'on sale' : 'full price',
        },
        price: {
            currency: product.price.currency?.label.toLowerCase(),
            basePrice: product.price.finalPrice,
            baseFullPrice: product.price.originalPrice || product.price.finalPrice,
        },
    }
}

export const trackAddToBag = ({ args, addToBagByProductColour, tracking, product, index }) => {
    tracking?.trackEvent({
        category: {
            primaryCategory: 'ecommerce',
            subCategory: 'checkout',
        },
        event: 'add to cart',
        effect: 'add to cart',
        item: [getItem({ product, index })],
    })

    return addToBagByProductColour(...args)
}

export const trackRefresh = (tracking) => {
    tracking?.trackEvent({
        category: {
            primaryCategory: 'ecommerce',
            subCategory: 'checkout',
        },
        event: 'update upsell list',
        effect: 'refresh upsell list',
    })
}
